export default function NotFound() {
    return <h2 align='center'>404 Not found</h2>
}